import {Typography, useTheme, css} from '@mui/material';
import {DlMuiDynamicIcon, GetStylesFunction} from '@wallaby-ui/core';
import {ICellRendererParams} from 'ag-grid-community';
import * as React from 'react';
import {FC} from 'react';

import {useFormatters} from '../light';
import {TooltipWrapper} from '../TooltipWrapper';

type OwnProps = ICellRendererParams;

type Props = OwnProps;

export const HaidiHaiStateFormattedChip: FC<{value: any; state: any; showAsText?: boolean; showTooltip?: boolean; textColor?: string}> = (
  props
) => {
  const {value, state, textColor, showAsText = false, showTooltip = true} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {showAsText, textColor}});
  const {tEnum} = useFormatters();

  const icon = getHaiStateIconByState(state);
  const formattedElement = (
    <span css={styles.chip} data-name='hai-state-formatter'>
      <DlMuiDynamicIcon
        iconName={icon.name}
        useFixedViewBox={icon.viewbox}
        inputCss={styles.iconButton}
        svgIconInputCss={styles.icon}
        noButtonStyles
      />
      <Typography css={styles.linkWrapper} variant={'value'}>
        {tEnum('State', value)}
      </Typography>
    </span>
  );
  return showTooltip ? <TooltipWrapper tooltip={tEnum('State', value)}>{formattedElement}</TooltipWrapper> : formattedElement;
};
HaidiHaiStateFormattedChip.displayName = 'HaidiHaiStateFormattedChip';

function getHaiStateIconByState(state: string | undefined) {
  /*
    "enum.state.col": "KOLONIZACE",
    "enum.state.no": "ZAMÍTNUTÁ",
    "enum.state.rep": "HLÁŠENÁ",
    "enum.state.wip": "ROZPRACOVANÁ",
    "enum.state.yes": "POTVRZENÁ"
   */
  const ICON_MAP: Record<string, {name: string; viewbox: number}> = {
    COL: {name: 'haiStateColIcon', viewbox: 12},
    NO: {name: 'haiStateNoIcon', viewbox: 12},
    REP: {name: 'haiStateRepIcon', viewbox: 12},
    WIP: {name: 'haiStateWipIcon', viewbox: 12},
    YES: {name: 'haiStateYesIcon', viewbox: 12},
    INITIAL: {name: '', viewbox: 12},
  };
  return ICON_MAP[state ?? ''] ?? {icon: 'missingStateError', viewbox: 12};
}

export const HaidiHaiStateFormatter: React.FC<Props> = (props) => {
  const {value, data} = props;

  return <HaidiHaiStateFormattedChip value={value} state={data.state} />;
};
HaidiHaiStateFormatter.displayName = 'HaidiHaiStateFormatter';

export function getHaiStateIcon(data) {
  return getHaiStateIconByState(data.state);
}

const getStyles: GetStylesFunction = (options) => ({
  chip: css`
    border-radius: 12px;
    padding: 3px 8px;
    padding-right: ${options?.params?.showAsText ? '2px' : '8px'};
    padding-top: ${options?.params?.showAsText ? '0px' : '3px'};
    padding-bottom: ${options?.params?.showAsText ? '0px' : '3px'};
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: ${options?.params?.showAsText ? undefined : '1px solid #e2e8f2'};
    background: ${options?.params?.showAsText ? 'unset' : '#ffffff'};
    color: #5d6f88;
    max-width: 100%;
  `,
  iconButton: css`
    padding: 0;
    background: none !important;
  `,
  icon: css`
    width: 13px;
    height: 13px;
  `,
  linkWrapper: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${options?.params?.textColor || 'currentColor'};
  `,
});
